module.exports = __webpack_public_path__ + "img/logo-footer-04.3095a19f.jpg";